import { render, staticRenderFns } from "./CorrectAnswerToggler.vue?vue&type=template&id=65a472c8&scoped=true"
import script from "./CorrectAnswerToggler.vue?vue&type=script&lang=js"
export * from "./CorrectAnswerToggler.vue?vue&type=script&lang=js"
import style0 from "./CorrectAnswerToggler.vue?vue&type=style&index=0&id=65a472c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a472c8",
  null
  
)

export default component.exports